import React from "react";
import { Icon, Spin } from "antd";

export default () => (
  <div style={{ textAlign: "center", marginTop: 64 }}>
    <Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} />
  </div>
);
